// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"214":"3ad07954","825":"150195b2"}[chunkId] + ".chunk.css";
};